import { Env } from './env';
import { regions } from './region/regions';
import { initBranding } from './branding/init-branding';

export const getApis = () => {
  const apis = [
    { value: 'stg', text: 'Staging API', cst: 'https://staging-customertoolkit.riamoneytransfer.com/', remittance: 'https://staging-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
    { value: 'prod', text: 'Production API', cst: 'https://customertoolkit.riamoneytransfer.com/', remittance: 'https://public.riamoneytransfer.com/', logApi: 'https://logs.riamoneytransfer.com/'  },
    { value: 'prod_la', text: 'Production LA', cst: 'https://la-customertoolkit.riamoneytransfer.com/', remittance: 'https://la-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
    { value: 'prod_kc', text: 'Production KC', cst: 'https://kc-customertoolkit.riamoneytransfer.com/', remittance: 'https://kc-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
    { value: 'pilot', text: 'Pilot', cst: 'https://pre-la-customertoolkit.riamoneytransfer.com/', remittance: 'https://pre-la-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
    { value: 'pilot_p1', text: 'Pilot P1', cst: 'https://p1-customertoolkit.riamoneytransfer.com/', remittance: 'https://p1-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
    { value: 'qa01_core', text: 'QA01 CST Core', cst: 'https://qa01-cstcore.riamoneytransfer.com/', remittance: 'https://qa01-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
    { value: 'stg_core', text: 'Staging CST Core', cst: 'https://staging-cstcore.riamoneytransfer.com/', remittance: 'https://staging-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
  ]
  const envQuantity = 50;
  for (let i = 0; i <= envQuantity; i++) {
    const number = String(i).length > 1 ? i : '0'+i;
    apis.push({ value: `QA${number}`, text: `QA${number} API`, cst: `https://qa${number}-customertoolkit.riamoneytransfer.com/`, remittance: `https://qa${number}-public.riamoneytransfer.com/`, logApi: 'https://staging-logs.riamoneytransfer.com/'  })
  }
  return apis;
}

export const config = {
  env: Env.PROD,
  RMT5_LEGACY_MODE: false, // CI-managed default; QA menu toggle overrides at runtime (non-PROD only)

  // MyRia
  API_URL: 'https://customertoolkit.riamoneytransfer.com/',
  GOOGLE_API_KEY: 'AIzaSyCdPfiYjLL7ZA84rD0SPO8uW75eFGs0Hyg',
  GOOGLE_ANALYTICS_ID: 'UA-93337072-1',
  IDNOW_COMPANY_ID: 'riafinancial',
  REMARKETING_TRACKING_ID: '834903991',
  REMARKETING_WEB: 'https://www.googleadservices.com/pagead/conversion/',
  // PRIVACY_POLICY: 'http://www.riafinancial.com/global/privacy-policy',
  PRIVACY_POLICY: 'https://ria-site.netlify.app/privacy-policy/',
  // TERMS_AND_CONDITIONS: 'http://www.riafinancial.com/global/terms-and-conditions',
  TERMS_AND_CONDITIONS: 'https://ria-site.netlify.app/terms-and-conditions/',
  TERMS_AND_CONDITIONS_PL: 'http://myriaapp.com/pl/TermsAndConditionsTransaction-pl.html',
  PUBLIC_SITE: "https://www.riamoneytransfer.com/",
  PRIVACY_POLICY_EKYC: 'http://myriaapp.com/es/PrivacyPolicyEKYC-es.html',
  EURONET_WW: 'http://www.euronetworldwide.com/',
  APP_STORE_ID: '1238779356',
  ITERABLE_INAPP_API: "https://api.iterable.com/",
  ITERABLE_INAPP_API_KEY: "0745e326a2444b2681ceb61e4b7a9352",
  // RMT
  remittanceApiBaseUrl: 'https://public.riamoneytransfer.com/',
  dingBaseUrl: 'https://checkout-ria.ding.com/',
  dingOrigin: 'https://checkout-ria.ding.com',
  // Ria-hosted page that iframes Ding; null opens Ding top-level directly
  dingHostedCheckoutUrl: 'https://secure.riamoneytransfer.com/topup/ding/checkout.html',
  logsApiUrl: 'https://logs.riamoneytransfer.com/',
  phpApiBaseUrl: '',
  XForwardFor: '66.82.123.234',
  fingerprintClientId: 'RMT',
  fingerprintClientSecret: '19qAs2VD0Un1tch54!!',
  threatMetrix: {
    url: 'https://h.online-metrix.net/tags',
    credentials: 'l6ixtwpr',
    pageId: '1',
  },
  timeoutTimerWarning: 540,
  timeoutTimer: 600,
  timeoutRelogin: 10800,
  timeoutGeolocation: 5000,
  maps: {
    baseUrl: 'https://api.mapbox.com/mapbox-gl-js/v2.2.0/mapbox-gl.js',
    apiKey: 'pk.eyJ1IjoiYXBpZWwtcmlhZmluYW5jaWFsIiwiYSI6ImNrbmIyeW0xZzB5d2MycHBqcmZ4bTZrbGgifQ.GLHYhlNaghB6obkBoJ5fkA',
    geoCoderUrl: 'https://unpkg.com/@mapbox/mapbox-sdk/umd/mapbox-sdk.min.js',
    styleSheet: 'https://api.mapbox.com/mapbox-gl-js/v2.2.0/mapbox-gl.css'
  },
  connectionTimeoutSettings: {
    requestTimeoutThreshold: 60,
  },
  loadingTimeoutMs: 70000,
  features: {
    logging: true,
  },
  regions: [regions.US, regions.CA, regions.FR, regions.DE, regions.IT, regions.LU, regions.BE, regions.NL, regions.AT, regions.IE, regions.DK, regions.FI,
            regions.SE, regions.NO, regions.UK, regions.ES, regions.LT, regions.CL, regions.AU, regions.MY, regions.PT, regions.CH, regions.SG, regions.PL, regions.NZ, regions.GR, regions.CZ, regions.RO, regions.SN, regions.PR],
  region: regions.US,
  paymentKycCheckRegions: [regions.MY , regions.SG],
  iovationScript: 'https://mpsnare.iesnare.com/snare.js',
  visaDirectScript: 'https://direct.dandelionpayouts.com/visadirect.min.js',
  cardinalScript: 'https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js',
  cardinalScriptV2: 'https://cas.static.client.cardinaltrusted.com/songbird/v2.1.3/songbird.js',
  enableLogToConsole: false,
  analyticsSettings: {
    segment: {
      methods: ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on'],
      baseUrl: 'https://cdn.segment.com/analytics.js/v1/',
      apiKey: 'a5ufg13AtNNmUmI6KWGOAv7yI3cOJ4MN',
    },
    businessUnit: 'RIA',
  },
  market: {
    androidUrl: 'https://play.google.com/store/apps/details?id=com.ria.moneytransfer',
    iosUrl: 'https://apps.apple.com/us/app/ria-money-transfer/id1065921908',
  },
  localProxy: false,
  otpTestPhoneNumber: null,
  logrocket: {
    key: '1sz4y0/rprod',
    console: {
      isEnabled: {
        log: false,
        debug: false,
      },
      shouldAggregateConsoleErrors: true, //Surface Console Errors in LogRocket
    },
    dom: {
      isEnabled: true,  //disable|enable all DOM recording
      inputSanitizer: true, // obfuscate all user-input elements <select> and <input>
    },
    network: {
      isEnabled: false,
    }
  },
  recaptchaKey: 'b5248f46-3913-406e-bc2e-82886f7a7700', // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  featureFlags: {
    findLocationRevamp: true,
    validationUpdatePhoneV2: true,
    lokaliseContent: true,
    emailageValidation: true,
    kroger: false,
    captcha: true,
    signinOld: false,
    showNewHomePage: true,
    recipientInteractionEventEnabled: true,
    usAuthPluginPasswordHint: false,
    checkPromosV2: false,
    useApplePayCreditSelect: true,
  },
  vueBridgeLocalUrl: null,
  recipientInteractionEventEndDate: "2025-05-31",
  automationTest: false,
  amplitudeHeader: false,
  previewFrame: false,
  showDebug: false,
  enforceRefresh:true,
  liteRegisterationMY: false,
  showActivityCarousel: true,
  showTransferStatusWidget: false,
  checkOriginalCountry: true,
  branding: initBranding,
  
  FintocPublicKey:'pk_live_BB6jb6pMieixj7UbqXSwhytKb7jDQasg',
  WalletCardChannelId: "MOBILEAPP",
  WalletCardChannelPassword: "Secure@2023**",
  zenDeskConfig:{
    agentAvailabilityurl:'https://launchpad-api.xe.com/care/agentavailability',
    integrationId: '66161e0b75d7da97936468e5',
    brandId: "360002607937"
  },

  apis: getApis(),
  selectedApi: null,
  reminderInterval: 'Monthly',
  contentConfigs: {},
  microBlinkLicenseKeys: {
    android: 'sRwCABVjb20ucmlhLm1vbmV5dHJhbnNmZXIAbGV5SkRjbVZoZEdWa1QyNGlPakUzTlRrME16QTNNVE13TkRBc0lrTnlaV0YwWldSR2IzSWlPaUl3Tm1RMlltVTFZUzAwTURRMkxURTBNek10WkRnM01DMW1ZVE16TXpZd01ETTNaRElpZlE9PUUyyNDfCe1cj81QmmhP0LLx2QXcw7oAP2UNKfNt9hYd/c3IruTkURsOUk+0l747WvWm58rYs3Bo88ii1DtYDRpoO3QnqQbc/lEhCRlx7kXkgXseI5vibG5i7d6RH3I=',
    ios: 'sRwCABhjb20ucmlhLlJJQU1vbmV5VHJhbnNmZXIBbGV5SkRjbVZoZEdWa1QyNGlPakUzTlRrME16QTVORE0wTVRNc0lrTnlaV0YwWldSR2IzSWlPaUl3Tm1RMlltVTFZUzAwTURRMkxURTBNek10WkRnM01DMW1ZVE16TXpZd01ETTNaRElpZlE9PSp6BaT5Fon5lv/bCjHAT3xM6isFLsyOxE0JtobyzgDuaJiiOJ5NT4wpFGBxmZpym5TvtZ+zCuAub+KqTwMFY/8uxZQDlfvWuz2A+EvNFcT5aIAjxk+PhNhrUouudLE='
  },
  amplitudeSessionTimeout: 660000,
  whatsappLink: 'https://wa.me',
  cdmWhatsappNumber: '+60123430034',
  eftDownIntrvalCall: 45000,
  SNHelplineNumber: '200223',
};



// WEBPACK FOOTER //
// ./src/environment/environment.prod.ts